export default __webpack_public_path__ + "static/media/mail.d148d7eb.svg";